/* eslint-disable import/prefer-default-export */

/**
 * Equivalent is:
 * new RegExp('(https://[-a-zA-Z0-9@:%_.~#=+/]+)/([-a-zA-Z0-9@:%_.~#=+]+)/app/(config/[A-Z0-9]+/)?([A-Z0-9]+)/([A-Z0-9]+)',);
 */
export const dossierUrlRegExp =
  /^(?<baseServerUrl>https:\/\/[-a-zA-Z0-9@:%_.~#=+/]+)\/(?<libraryName>[-a-zA-Z0-9@:%_.~#=+]+)\/app\/(config\/(?<configID>[A-Z0-9]+)\/)?(?<projectID>[A-Z0-9]+)\/(?<dossierID>[A-Z0-9]+)/;
export const libraryUrlRegExp =
  /^(?<baseServerUrl>https:\/\/[-a-zA-Z0-9@:%_.~#=+]+)\/(?<libraryName>[-a-zA-Z0-9@:%_.~#=+]+)(\/app\/config\/(?<configID>[A-Z0-9]+))?$/;
// Matches "G{Id}" need to update if G is not the only prefix. /i is case insenstive setting for regex.
export const exampleSearchUrlRegExp = /^\?example=(?<exampleId>G[0-9]+)$/i;
